export const environment = {
  production: false,
  envName: 'qa',
  apiBaseUrl: 'https://uatapi.arrivae.com',
  uiBaseUrl: 'https://arrivae-qa-product.firebaseapp.com/',
  pptUrl: 'qa'
};



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/environments/environment.ts